
			document.addEventListener("DOMContentLoaded", function () {
				// window.onload = function () {
				const swiper02 = new Swiper(".slide_item .swiper", {
					loop: true,
					speed: 1500,
					slidesPerView: 1,
					centeredSlides: false,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
						dynamicBullets: false,
					},
					breakpoints: {
						768: {
							slidesPerView: 2,
							spaceBetween: 20,
						},

						1024: {
							slidesPerView: 3,
						},
					},
				});

				const swiper03 = new Swiper(".slide_item.last_slide .swiper", {
					loop: false,
					speed: 1500,
					slidesPerView: 1,
					centeredSlides: false,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					pagination: {
						el: ".swiper-pagination02",
						clickable: true,
						dynamicBullets: false,
					},
					breakpoints: {
						768: {
							slidesPerView: 2,
							spaceBetween: 20,
						},

						1024: {
							slidesPerView: 5,
							allowTouchMove: false,
						},
					},
				});

				// };
			});

